export default "__VITE_ASSET__77b332be__"